import { RequestRegistrationCodeResponse, VerifyOtpResponse } from './model';
import { publicRest } from '@xolv-mybrightlink/common';

export const requestOtp = async (phoneNumber: string): Promise<void> => {
  await publicRest.post('/user/request-login-code', {
    user_id: phoneNumber,
    device_type: 'WEB',
  });
};

export const verifyOtp = async (
  phoneNumber: string,
  otp: string,
): Promise<VerifyOtpResponse> => {
  const response = await publicRest.post<VerifyOtpResponse>(
    '/user/authenticate',
    {
      user_id: phoneNumber,
      password: otp,
      app_version: '2.28.0',
    },
  );
  return response.data;
};

export const requestRegistrationCode = async (
  phoneNumber: string,
  zipCode: string,
): Promise<RequestRegistrationCodeResponse> => {
  const response = await publicRest.post<RequestRegistrationCodeResponse>(
    '/user/request-registration-code',
    {
      phone_number: phoneNumber,
      zip_code: zipCode,
      device_type: 'WEB',
    },
  );
  return response.data;
};

export const createAccount = async (
  phoneNumber: string,
  zipCode: string,
  sfContactId: string,
  otp: string,
  hiaAgreementTime: Date,
  tosAgreementTime: Date,
): Promise<void> => {
  await publicRest.post('/user', {
    user_id: phoneNumber,
    zip_code: zipCode,
    sf_contact_id: sfContactId,
    password: otp,
    hia_agreement_date: hiaAgreementTime.toISOString(),
    tos_agreement_date: tosAgreementTime.toISOString(),
    app_version: '2.28.0',
  });
};
